import React from 'react';
import { useIntl } from 'react-intl';
import { v4 as uuid } from 'uuid';

import {
  CardFlexGridWrapper,
  CardWrapper,
  Title,
  CardViewed,
  ButtonLink,
  PageContainer,
  ContainerCustom,
  TitleLink,
} from 'components';

import {
  TitleMain,
  CardViewedVillas,
  CardPopular,
  CardPopularWrapper,
} from '../Main.styles';
import { ScrollContainer } from './CarouselContainer';
import { MobileDeviceBreakpoint } from './Header/SearchBarPanel.styles';
const pluralize = require('numeralize-ru').pluralize;

const ViewedVillas = ({
  dataViewed,
  loading,
  setFavoriteVillas,
  favoriteVillas,
}) => {
  const intl = useIntl();
  console.log('jnjsndf', dataViewed);
  return (
    <>
      <MobileDeviceBreakpoint mobileMGridHidden>
        {dataViewed && dataViewed.viewedProps.propsList.length > 0 && (
          <ContainerCustom width="fit-content" margin="0">
            <Title
              paddingFrom1890="0"
              padding1890="0"
              size="18px"
              margin="80px 0 0 0"
              marginTablet="60px 0 0 0"
              mutedText
            >
              {intl.formatMessage({
                id: 'main-page.resently-viewed',
              })}
            </Title>

            <TitleMain
              paddingFrom1890="0"
              padding1890="0"
              display="flex"
              align="center"
              justify="space-between"
              size="36px"
              weight="500"
              sizeM="18px"
              margin="0 0 50px 0"
            >
              {intl.formatMessage({
                id: 'main-page.shown-objects',
              })}
              <TitleLink
                display="flex"
                widthSm="fit-content"
                align="center"
                justify="center"
                color="#943FA1"
                weight="400"
                size="18px"
                weight="500"
                sizeM="12px"
                target="blank"
                to={`/${localStorage.language}/my/viewed`}
              >
                {intl.formatMessage({
                  id: 'viewed-page.check-all',
                })}
              </TitleLink>
            </TitleMain>
            <CardFlexGridWrapper
              // margin="auto 5vw"
              // marginM="auto"
              display="grid"
              gridGap="min(1.2vw,28px)"
              gridColumns="repeat(3, min(29vw,560px))"
            >
              {dataViewed &&
                dataViewed.viewedProps &&
                dataViewed.viewedProps.propsList.map((hotel) => (
                  <CardViewed
                    setFavoriteVillas={setFavoriteVillas}
                    favoriteVillas={favoriteVillas}
                    loading={loading}
                    key={uuid()}
                    hotel={hotel}
                    margin="0"
                  />
                ))}
            </CardFlexGridWrapper>
          </ContainerCustom>
        )}
      </MobileDeviceBreakpoint>
      <MobileDeviceBreakpoint tabletGridHidden>
        {dataViewed && dataViewed.viewedProps.propsList.length > 0 && (
          <>
            <ContainerCustom margin="20px 0 0 0" marginTablet="0">
              <PageContainer
                maxWidth="1440px"
                marginSm="0"
                margin="0"
                padding="0 80px"
                minHeight="auto"
                padding1100="0 5vw 25px 0"

                // padding="0 25px"
              >
                <Title size="12px" mutedText>
                  {intl.formatMessage({
                    id: 'main-page.resently-viewed',
                  })}
                </Title>
                <TitleMain
                  size="36px"
                  size1100="24px"
                  weight="500"
                  sizeM="18px"
                  margin="0 0 4px 0"
                  display="flex"
                  align="center"
                  justify="space-between"
                >
                  {intl.formatMessage({
                    id: 'main-page.shown-objects',
                  })}
                  <TitleLink
                    display="flex"
                    widthSm="fit-content"
                    align="center"
                    justify="center"
                    color="#943FA1"
                    weight="400"
                    size="16px"
                    sizeM="12px"
                    target="blank"
                    to={`/${localStorage.language}/my/viewed`}
                  >
                    {intl.formatMessage({
                      id: 'viewed-page.check-all.short',
                    })}
                  </TitleLink>
                </TitleMain>
              </PageContainer>
              <ScrollContainer itemsList={dataViewed.viewedProps.propsList}>
                <CardViewed
                  setFavoriteVillas={setFavoriteVillas}
                  favoriteVillas={favoriteVillas}
                />
              </ScrollContainer>
            </ContainerCustom>

            {/* <ButtonLink
              display="flex"
              align="center"
              justify="center"
              size="16px"
              width="144px"
              height="54px"
              sizeM="14px"
              margin="0 auto 0 auto"
              marginSM="-27px auto 0 auto"
              primary
              target="blank"
              to={`/${localStorage.language}/my/recommended`}
            >
              {intl.formatMessage({
                id: 'buttons.all-objects',
              })}
            </ButtonLink> */}
          </>
        )}
      </MobileDeviceBreakpoint>
    </>
  );
};
export default ViewedVillas;
